// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import NextGameController from "./next_game_controller";
application.register("next-game", NextGameController);

import LocalTimeController from "./local_time_controller";
application.register("local-time", LocalTimeController);

import CopyController from "./copy_controller";
application.register("copy", CopyController);
